export default "__VITE_ASSET__CgwjZezP__"